'use client';
import React from 'react';
import StoryContent from './StoryContent';
import ArtHeader from '../ArtHeader';
import ArtHeadBlock from '../ArtHeadBlock';
import { Desktop } from '@components/Desktop';
import { ImageObj } from '../../../types/ImageObj.types';
import cn from './style.module.scss';

type Props = {
  t: Record<string, string>;
  logoSrc: ImageObj;
  bannerSrc: ImageObj;
  mobileThemeSrc: ImageObj;
  desktopThemeSrc: ImageObj;
  shapeDesktopImg: ImageObj;
  shapeMobileImg: ImageObj;
  localeOptions: { value: string; label: string }[];
};
export default function ArtBanner(props: Props) {
  const { t } = props;

  return (
    <>
      <ArtHeader t={t} launch localeOptions={props.localeOptions} />
      <section
        data-notranslate
        className={cn.artBanner}
        data-key={props.bannerSrc?.name}
        style={{
          backgroundImage: `url(${props.bannerSrc?.url})`,
        }}
      >
        <div className={cn.bannerWrapper}>
          <div className={cn.bannerBody}>
            <ArtHeadBlock>
              <div className={cn.bannerTheme}>
                <div className={cn.themeArthouse}>
                  <div className={cn.athouseLogo}>
                    <span>
                      <img
                        src={props.logoSrc?.url}
                        alt={props.logoSrc?.alt}
                        data-key={props.logoSrc?.name}
                      />
                    </span>
                  </div>
                </div>
                <div className={cn.themeStory}>
                  <div className={cn.themeImage}>
                    <div
                      className={cn.themeMobile}
                      data-key={props.mobileThemeSrc?.name}
                      style={{
                        backgroundImage: `url(${props.mobileThemeSrc?.url})`,
                      }}
                    >
                      <StoryContent {...props} />
                    </div>
                    <div
                      className={cn.themeDesktop}
                      data-key={props.desktopThemeSrc?.name}
                      style={{
                        backgroundImage: `url(${props.desktopThemeSrc?.url})`,
                      }}
                    >
                      <StoryContent {...props} />
                    </div>
                  </div>
                </div>
                <div className={cn.themeArrow}>
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 22.993 102.084"
                    >
                      <path
                        d="M53,106.872l11.009,5.98L63.994,22h1l-.03,90.864,11.03-5.992L64.5,124.049l0,.035Z"
                        transform="translate(-53 -22)"
                        fill="#f8f3ee"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </ArtHeadBlock>
          </div>
        </div>
        <Desktop>
          <div className={cn.bannerColor}>&nbsp;</div>
        </Desktop>
      </section>
    </>
  );
}
